export default ($wire, { tabHidableInputsHidden }) => ({
    activeTab: $wire.entangle('activeTab').live,
    hidableInputsHidden: tabHidableInputsHidden,
    switchToTab(tab) {
        this.activeTab = tab;
    },
    toggleInputsHidden() {
        this.hidableInputsHidden = !this.hidableInputsHidden;
    },
});
